import React from 'react'
import './StartButton.css';
type Props = {}

const StartButton = (props: Props) => {
  return <button className='start'>Başla</button>
}

export default StartButton